// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.typekit.net/xxi0uje.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cruxtify-page-single .single-model-wrap[data-v-6deadec0]{width:100%}.cruxtify-page-single .model-title-col[data-v-6deadec0]{flex-grow:2}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
